<div
  #mainDiv
  cdkDrag
  [cdkDragData]=""
  (cdkDragEnded)="dragDropped($event)"
  (cdkDragStarted)="dragStarted()"
  cdkDragBoundary=".pdf-drag-overlay"
  [ngStyle]="containerStyleObs | async"
  [cdkDragFreeDragPosition]="dragPositionObs | async"
  class="signature-container"

>
  <ss-signature-toolbar></ss-signature-toolbar>

  <div
    #signatureDiv
    class="border-radius-smaller position-relative padding-smaller z-10000"
    [ngStyle]="signatureStyleObs | async"
  >
    <h6 class="position-top-left light-bold mat-body-2" [ngStyle]="{color:textColorObs |async}">{{fullNameObs | async}}</h6>
    <div
      cdkDragHandle
      class="signature-drag-handle"
      
    ></div>


    <mat-icon *ngIf="isFirefox" ssResizeBtn [resizeElement]="mainDiv" class="resize-button">chevron_right</mat-icon>
  </div>
</div>
